import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useCopyValue } from '../../../../hooks'
import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { QA_NAME_DASHBOARD_BIRDVIEW_HOME_COPY } from '../../DashboardBirdview.constants.qa'

import CopyIcon from '../../../../icons/copy.svg'

function BirdviewHomeRowCopyButton({ value }) {
  const { t } = useTranslation()

  const { copied, handleCopy } = useCopyValue({
    successNotificationKey: 'DashboardBirdview.CopiedNotificationKey',
    value,
  })

  return (
    <Button.Text
      isGrey
      beforeIconProps={{ Icon: CopyIcon }}
      disabled={copied}
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_HOME_COPY}
      tooltip={t('DashboardBirdview.ClickToCopyTooltipKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleCopy}
    />
  )
}

export default BirdviewHomeRowCopyButton
